<footer class="main-footer">
  <div class="footer-container">
    <div class="footer-content">
      
      <div class="footer-column">
        <a href="#" class="footer-logo-link">
          <span class="material-icons-outlined footer-logo-icon">local_car_wash</span>
          <div class="logo-text-group"> 
            <h1 class="logo-title">The Detailer</h1>
            <p class="logo-subtitle">Wash & Detailing</p>
          </div>
        </a>
        <p class="copyright">© 2026 The Detailer. Todos los derechos reservados.</p>
      </div>

      <div class="footer-column">
        <h3 class="footer-heading">Contacto</h3>
        <ul class="footer-list">
          <li class="footer-list-item">
            <span class="material-icons-outlined footer-icon">email</span> 
            info@thedetailer.com
          </li>
          <li class="footer-list-item">
            <span class="material-icons-outlined footer-icon">phone</span> 
            +57 312 773 65 69
          </li>
          <li class="footer-list-item">
            <span class="material-icons-outlined footer-icon">location_on</span> 
            Cra. 18 #2-13 Barrio Galan.
            <br>
            Cra. 06 #7-30 AV.Centenario.
          </li>
        </ul>
      </div>

      <div class="footer-column">
        <h3 class="footer-heading">Enlaces Rápidos</h3>
        <ul class="footer-list">
          <li>
            <a [routerLink]="['./']" fragment="nosotros" class="footer-link">Quiénes Somos</a>
          </li>
          <li>
            <a [routerLink]="['./']" fragment="contacto" class="footer-link">Contacto</a>
          </li>
        </ul>
      </div>

    </div>
  </div>
</footer>